const hasPermission = (user = {}, permissionsNeeded = []) => {
  if (!user?.permissions || !permissionsNeeded) {
    return false;
  }
  const matchedPermissions = user?.permissions?.filter((permissionTheyHave) => {
    return permissionsNeeded.includes(permissionTheyHave);
  });

  //* Alternate check that works
  // const testMatch = user?.permissions?.some((stuff) => {
  //   return permissionsNeeded.includes(stuff);
  // });
  // console.log('testMatch:', testMatch);

  function UserException(message) {
    this.message = message;
    this.name = 'UserException';
  }
  if (!matchedPermissions?.length) {
    return false;
    // throw new Error(`You do not have sufficient permissions: ${permissionsNeeded}
    //   You Have: ${user.permissions}`);
    // throw new UserException(`You do not have sufficient permissions:
    //   You Need: ${permissionsNeeded}
    //   You Have: ${user.permissions}`);
  }

  return true;
};

export { hasPermission as default };
